export default __webpack_public_path__ + "static/ProValue_2@768-db20e1d2e2e5bb4cd63bceaecc93ce96.png";